if (!customElements.get('product-card-splide')) {
  class ProductCardSplide extends HTMLElement {
    constructor() {
      super();
      this.mounted = false;
    }

    connectedCallback() {
      // Small delay to ensure Splide library is loaded and DOM is parsed
      this.init();
    }

    init() {
      if (this.mounted) return;

      const attemptMount = () => {
        if (typeof Splide !== 'undefined') {
          this.mountSplide();
        } else {
          // If Splide isn't loaded yet, try again in 100ms
          setTimeout(attemptMount, 100);
        }
      };

      attemptMount();
    }

    mountSplide() {
      if (this.mounted || !this.querySelector('.splide__track')) return;

      try {
        const slider = new Splide(this, {
          type: 'loop',
          perPage: 1,
          arrows: true,
          pagination: true,
          drag: true,
          gap: 0,
          rewind: true,
          // If your arrows aren't showing correctly on AJAX load, 
          // ensure they are created:
          arrows: this.querySelectorAll('.splide__slide').length > 1,
          pagination: this.querySelectorAll('.splide__slide').length > 1
        });

        slider.mount();
        this.mounted = true;
      } catch (e) {
        console.error('Splide mount error:', e);
      }
    }
  }
  customElements.define('product-card-splide', ProductCardSplide);
}

